
import React   from "react";


import DashboardChoices from "./DashboardChoices";
import DashboardFiltres from "./DashboardFiltres";
import DashBoardLeads from "./DashBoardLeads";
import DashboardTop from "./DashboardTop";
import ListEvents from "../../Components/Calendar/ListEvents";

import './EcranDashboard.scss'; 

function EcranDashboard(){

     return(<div className="dashboard" >
                <DashboardTop />
                <DashboardChoices  />
                <DashboardFiltres  />
                <DashBoardLeads   />
                <ListEvents  position="fixedright" />
            </div>);
}


export default EcranDashboard ; 